import CategoriesSelect from "./CategoriesSelect";

export default CategoriesSelect;